import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Patient API calls
export const patientAPI = {
  getAll: (page = 1, limit = 10) => 
    api.get(`/api/patients?page=${page}&limit=${limit}`),
  
  getById: (id) => 
    api.get(`/api/patients/${id}`),
  
  create: (data) => 
    api.post('/api/patients', data),
  
  update: (id, data) => 
    api.put(`/api/patients/${id}`, data),
  
  delete: (id) => 
    api.delete(`/api/patients/${id}`)
};

// Chat API calls
export const chatAPI = {
  sendMessage: (patientId, message) => 
    api.post('/api/chat', { patientId, message }),
  
  getHistory: (patientId) => 
    api.get(`/api/chat/${patientId}`)
};

export default api;